export enum ResponseStatus {
  COMPLETE = 'complete',
}
